import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { ActivityProcessParametrizationService } from '../proxy/controlling/controllers/activity-process-parametrization.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { LocationTypeService } from '@planning/proxy/planning/controllers/location-type.service';

FieldBuilder.setNamespace('Controlling');

export const LOGISTICSACTIVITYPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('liquidatesWithIva', 'Entity.LogisticsActivityParameter.LiquidatesWithIVA')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('locationTypeId', 'Entity.LogisticsActivityParameter.LocationType', LocationTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('activityProcessParametrizationId', 'Entity.ActivityProcessParametrization', ActivityProcessParametrizationService)
    .required()
    .display('name')
    .keyField('id')
    .hideInChildForms()
    .build(),
  FieldBuilder
    .foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name') 
    .sortBy('wbs.name') 
    .build(),
];

export const LOGISTICSACTIVITYPARAMETER_CONFIG = {
  entityName: 'LogisticsActivityParameter',
  localizationKey: 'Controlling::Entity.LogisticsActivityParameter',
  fields: LOGISTICSACTIVITYPARAMETER_FIELDS,
  permission: 'ControllingActivities.LogisticsActivityParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
